import React from 'react';
import classNames from 'classnames';

import css from './IconLock.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconAdd = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 100 125"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M75.3,38.8h-2.8c0,0,0,0,0,0h0V28c0-12.9-9.3-23-22.6-23C36.6,5,27.5,15.3,27.5,28v10.7h0c0,0.1,0,0.1,0,0h-2.8  c-6.2,0-11.2,5-11.3,11.3v33.8c0,6.2,5,11.2,11.3,11.3h50.6c6.2,0,11.2-5,11.3-11.3V50C86.6,43.8,81.5,38.8,75.3,38.8z M33.1,38.8  V28c0-9.6,6.6-17.4,16.8-17.4c10.1,0,17,7.6,17,17.4v10.7h0c0,0.1,0,0.1,0,0c0,0,0,0,0,0H33.1C33.1,38.8,33.1,38.8,33.1,38.8  L33.1,38.8z M80.9,83.8c0,3.1-2.5,5.6-5.6,5.6H24.7c-3.1,0-5.6-2.5-5.6-5.6V50c0-3.1,2.5-5.6,5.6-5.6h50.6c3.1,0,5.6,2.5,5.6,5.6  V83.8z M55.6,61.3c0,2.1-1.1,3.9-2.8,4.9h-0.1c0,0,0.1,0,0.1,0v9.2c0,1.6-1.3,2.8-2.8,2.8c-1.6,0-2.8-1.3-2.8-2.8v-9.2  c0,0,0.1,0,0.1,0h-0.1c-1.7-1-2.8-2.8-2.8-4.9c0-3.1,2.5-5.6,5.6-5.6C53.1,55.6,55.6,58.1,55.6,61.3z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default IconAdd;
